// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import HotelJpeg from '../../assets/images/hotel.jpg';
// import LogoSvg from '../../assets/images/logo.svg';
// import EyeSvg from '../../assets/images/eye.svg';
// import copy from '../../assets/images/copyright.svg';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import './LoginPage.css';
// import apiService from '../../api/apiService';
// import { saveAuthData } from '../../auth';
// import HotelProLogoWhite from '../../assets/images/hotel-pro-logo-white.svg';

// const LoginPage = () => {
//   localStorage.removeItem('token');
//   const [showPassword, setShowPassword] = useState({ password: false });
//   const [username, setUsername] = useState('');
//   const [password, setPassword] = useState('');
//   const navigate = useNavigate();
//   const [isSignUp, setIsSignUp] = useState(false);

//   const togglePasswordVisibility = field => {
//     setShowPassword(prev => ({ ...prev, [field]: !prev[field] }));
//   };

//   const handleLogin = async e => {
//     e.preventDefault();

//     if (!username || !password) {
//       toast.error('Please enter your credentials.', {
//         autoClose: 1500,
//       });
//       return;
//     }

//     try {
//       const response = await apiService.post('/login/', {
//         username,
//         password,
//       });
//       saveAuthData(response);

//       toast.info('Signing in...', {
//         autoClose: 1000,
//         onClose: () => navigate('/dashboard'),
//       });
//     } catch (error) {
//       console.error(error);
//       toast.error(
//         error.response?.detail || 'Invalid credentials. Please try again.',
//         {
//           autoClose: 1500,
//         }
//       );
//     }
//   };

//   return (
//     <>
//       <ToastContainer />
//       <div className="row main align-items-center h-100">
//         <div className="col-md-6 bg-white p-0 h-100 p-5">
//           <div>
//             <h2 className="text-lg font-bold mt-4">Sign in to your account</h2>
//             <form className="mt-4 space-y-4" onSubmit={handleLogin}>
//               <div className="col-12 text-center mt-3">
//                 <div className="inputbox m-auto">
//                   <input
//                     type="text"
//                     placeholder="Username"
//                     className="hbox"
//                     value={username}
//                     onChange={e => setUsername(e.target.value)}
//                   />
//                 </div>
//               </div>
//               <div className="col-12 text-center mt-3">
//                 <div className="inputbox m-auto">
//                   <input
//                     type={showPassword.password ? 'text' : 'password'}
//                     placeholder="Password"
//                     className="hbox"
//                     value={password}
//                     onChange={e => setPassword(e.target.value)}
//                   />
//                   <img
//                     src={EyeSvg}
//                     onClick={() => togglePasswordVisibility('password')}
//                     className="eye mt-3"
//                     alt="Toggle Password"
//                   />
//                 </div>
//               </div>
//               <div className="col-12 mb-5 mt-2">
//                 <button type="submit" className="btn buttons db bbutton">
//                   <span>Sign In</span>
//                 </button>
//               </div>
//             </form>
//           </div>

//         </div>

//         <div
//           className="col-md-6 p-0 d-none d-md-block"
//           style={{ height: '100vh' }}
//         >
//           <img
//             src={HotelJpeg}
//             alt="Hotel Background"
//             className="probackimg h-100"
//           />

//           <div className="PA h-100 text-center text-white img-text-wrapper d-flex flex-column justify-content-around align-items-center">
//             <div className="flex flex-column">
//               <img
//                 src={HotelProLogoWhite}
//                 alt="HotelPro Logo"
//                 className="mb-3  pro"
//                 style={{ marginTop: 160 }}
//               />
//               <span className="ps">Sondermall Palace</span>
//             </div>
           
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default LoginPage;
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import apiService from "../../api/apiService";
import { saveAuthData } from "../../auth";

import HotelJpeg from "../../assets/images/hotel.jpg";
import HotelProLogoWhite from "../../assets/images/hotel-pro-logo-white.svg";
import EyeSvg from "../../assets/images/eye.svg";

import "./LoginPage.css";

const LoginPage = () => {
  localStorage.removeItem("token");
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!username || !password) {
      toast.error("Please enter your credentials.", { autoClose: 1500 });
      return;
    }

    try {
      const response = await apiService.post("/login/", { username, password });
      saveAuthData(response);

      toast.info("Signing in...", {
        autoClose: 1000,
        onClose: () => navigate("/dashboard"),
      });
    } catch (error) {
      console.error(error);
      toast.error(
        error.response?.detail || "Invalid credentials. Please try again.",
        { autoClose: 1500 }
      );
    }
  };

  return (
    <div
      className="login-container"
      style={{ backgroundImage: `url(${HotelJpeg})` }}
    >
      <ToastContainer />
      <div className="login-card">
        <div className="login-header">
          <img src={HotelProLogoWhite} alt="HotelPro" className="login-logo" />
          <h2>Welcome Back</h2>
          <p>Sign in to continue</p>
        </div>

        <form className="login-form" onSubmit={handleLogin}>
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="login-input"
          />

          <div className="password-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="login-input"
            />
            <img
              src={EyeSvg}
              alt="Toggle Password"
              className="eye-icon"
              onClick={togglePasswordVisibility}
            />
          </div>

          <button type="submit" className="login-button">
            Sign In
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
